<template>
  <div class="card h-100">
    <div class="card-body padding2">
      <div class="card-text">
        <div v-if="player.pic">
          <LogoLarge :path="player.pic"></LogoLarge>
        </div>
        <div class="fw-bold smalltxt">{{ player.name }}</div>
        <ul class="list-group">
          <li
            class="list-group-item smalltxt padding2"
            v-for="(b, index) in bids"
            :key="b.id"
          >
            <div class="row d-flex align-items-center tinytxt">
              <div class="col text-start">
                <TeamName :team_id="b.team_id"></TeamName>
              </div>
              <div class="col text-end">{{ b.amount }}</div>
              <div class="col">
                <button
                  class="btn btn-sm btn-primary padding2 tinytxt"
                  v-if="index == 0"
                  @click="sellPlayer()"
                >
                  Sell
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script setup>
import supabase from "@/supabase/config";
import { computed, defineProps, onMounted, ref } from "vue";
import { useStore } from "@/store/index";
//import PhotoMedium from "../../bidder/liveplayer/PhotoMedium.vue";
import LogoLarge from "../../bidder/logos/LogoLarge.vue";
import TeamName from "../../bidder/bidbuttons/TeamName.vue";
const store = useStore();
const props = defineProps(["player"]);
const player = ref({});

onMounted(() => {
  setTimeout(() => {
    player.value = props.player;
  }, 1000);
});
const bids = computed(() => {
  var arr = [];
  if (player.value.id) {
    arr = store.unsold_bids.filter((bid) => bid.player_id === player.value.id);
    arr = arr.sort((a, b) => b.amount - a.amount);
  }
  return arr;
});
</script>
<style scoped>
.smalltxt {
  font-size: 12px;
}
.padding2 {
  padding: 2px;
}
.tinytxt {
  font-size: 10px;
}
</style>
